import {
  SET_ARTIST_EXPERIENCE_CATEGORY_LIST,
  SET_EXPERIENCE_TYPE_LIST,
  SET_LOADING,
  SET_LOCATION_LIST,
  SET_RECRUITER_EXPERIENCE_CATEGORY_LIST,
  SET_REPORT_TYPE_LIST,
} from "../../actions/general/types";

const INITIAL_STATE = {
  loading: false,
  locationList: [],
  artistExperienceCategoryList: [],
  recruiterExperienceCategoryList: [],
  experienceYearList: [],
  reportTypes: [],
};

const GeneralReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case SET_ARTIST_EXPERIENCE_CATEGORY_LIST: {
      return {
        ...state,
        artistExperienceCategoryList: action.payload,
      };
    }
    case SET_RECRUITER_EXPERIENCE_CATEGORY_LIST: {
      return {
        ...state,
        recruiterExperienceCategoryList: action.payload,
      };
    }
    case SET_LOCATION_LIST: {
      return {
        ...state,
        locationList: action.payload,
      };
    }
    case SET_REPORT_TYPE_LIST: {
      return {
        ...state,
        reportTypes: action.payload,
      };
    }
    case SET_EXPERIENCE_TYPE_LIST: {
      return {
        ...state,
        experienceYearList: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default GeneralReducer;
